import { AppEntities } from "../../../../config/entities";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";

const VehicleList = () => {
    const fields = [
        { title: "Name", fieldName: "name" },
    ];

    return (
        <>
            <NewCatalogListView fields={fields} entity={AppEntities.Vehicle} />
        </>
    );
}

export default VehicleList;